import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { TaskMasterSet } from 'entities/task_master_set'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateTimeText } from 'utils/util'

export const taskMasterSetColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'task_master_set_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '作成日', th: true, width: 130, form: form, orderAttr: 'task_master_set_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: '作成者', th: true, width: 120, form: form, orderAttr: 'task_master_set_user_id' },
            { name: 'タイトル', th: true, minWidth: 200, form: form, orderAttr: 'task_master_set_title', searchType: { name: 'title', type: 'text' } },
            { name: 'タスク数', th: true, width: 90, align: 'center' },
        ],
    }
}

export type TaskMasterSetTableDataProps = {
    taskMasterSet?: TaskMasterSet
    displaySetting: DisplaySetting
}

export const TaskMasterSetTableData = ({ taskMasterSet, displaySetting }: TaskMasterSetTableDataProps): JSX.Element => {
    if (!taskMasterSet) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{taskMasterSet.id}</TableCell>
                <TableCell>{toDateTimeText(taskMasterSet.createdAt)}</TableCell>
                <TableCell>{taskMasterSet.user?.fullName}</TableCell>
                <TableCell>{taskMasterSet.title}</TableCell>
                <TableCell align="center" unit="個">
                    {taskMasterSet.taskMasters?.length}
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
